<template>
        <v-layout class="fill-height">
            <v-container
                id="contentDashboard" fluid
                class="fill-height"
            >
                <v-snackbar
                v-model="snackbar"
                :color="color"
                right
                top
                app
                >
                {{snackbarText}}
                <v-btn
                    text
                    dark
                    @click="snackbar = false"
                >
                    Fermer
                </v-btn>
                </v-snackbar>
                <v-layout>
                <v-row
                    align="start"
                    justify="start"
                >
                    <v-col cols="12" class="pt-1">
                    <header-sidebar></header-sidebar>
                    <v-card class="table-content">
                        <v-card-title>
                            <div class="text-left">
                                <span style="font-weight:700">Statistiques</span>
                            </div>
                        <v-spacer></v-spacer>
                        <v-btn style="float:right; background: linear-gradient(90deg, rgba(13,74,186,1) 0%, rgba(9,155,223,1) 100%); margin-right:10px;" depressed small color="primary">Gestion des Privilèges</v-btn>
                        </v-card-title>
                        <v-card-text class="pa-0">
                            <v-row class="text-left" style="width:100%; margin:0;">
                                <v-col cols="12" md="12">
                                    <apexchart type="bar" height="350" width="100%" :options="chartOptions" :series="series"></apexchart>
                                </v-col>
                                <v-col cols="12" md="6">
                                    <apexchart type="area" height="350" :options="chartOptions1" :series="series1"></apexchart>
                                </v-col>
                                <v-col cols="12" md="6">
                                    <apexchart type="donut" width="380" :options="chartOptions3" :series="series3"></apexchart>
                                </v-col>
                                
                                <v-col cols="12" md="6">
                                    <apexchart type="bar" height="430" :options="chartOptions2" :series="series2"></apexchart>
                                </v-col>
                                
                            </v-row>
                        </v-card-text>
                    </v-card>
                    </v-col>
                </v-row>
            </v-layout>
        </v-container>
    </v-layout>
</template>
<script>
import VueApexCharts from 'vue-apexcharts'
import headerSidebar from '../commons/header_sidebar.component' 
    export default {
        name: 'statistics',
        components: { headerSidebar , apexchart: VueApexCharts},
        data: () => ({
            snackbar: false,
            color: 'error',
            snackbarText: '',
            series: [{
                name: 'Import',
                data: [44, 55,55,55, 57, 56, 61, 58, 63, 60, 66]
                }, {
                name: 'Export',
                data: [76, 85, 101, 101, 101, 98, 87, 105, 91, 114, 94]
            }],
            chartOptions: {
                chart: {
                    type: 'bar',
                    height: 350,
                    width: "100%"
                },
                plotOptions: {
                    bar: {
                    horizontal: false,
                    columnWidth: '55%',
                    endingShape: 'rounded'
                    },
                },
                dataLabels: {
                    enabled: false
                },
                stroke: {
                    show: true,
                    width: 1,
                    colors: ['transparent']
                },
                xaxis: {
                    categories: ['Jan','Feb', 'Mar', 'Apr', 'May', 'Jun', 'Jul', 'Aug', 'Sep', 'Oct','Nov','Dec'],
                },
                yaxis: {
                    title: {
                    text: 'Milles TND'
                    }
                },
                fill: {
                    opacity: 1
                },
                tooltip: {
                    y: {
                        formatter: function (val) {
                            return val + " Milles TND"
                        }
                    }
                }
            },
            series1: [{
                name: 'series1',
                data: [31, 40, 28, 51, 42, 109, 100]
            }, {
                name: 'series2',
                data: [11, 32, 45, 32, 34, 52, 41]
            }],
            chartOptions1: {
                chart: {
                height: 350,
                type: 'area'
                },
                dataLabels: {
                enabled: false
                },
                stroke: {
                curve: 'smooth'
                },
                xaxis: {
                type: 'datetime',
                categories: ["2018-09-19T00:00:00.000Z", "2018-09-19T01:30:00.000Z", "2018-09-19T02:30:00.000Z", "2018-09-19T03:30:00.000Z", "2018-09-19T04:30:00.000Z", "2018-09-19T05:30:00.000Z", "2018-09-19T06:30:00.000Z"]
                },
                tooltip: {
                    x: {
                        format: 'dd/MM/yy HH:mm'
                    },
                },
            },
            series2: [{
                data: [44, 55, 41, 64, 22, 43, 21]
            }, {
                data: [53, 32, 33, 52, 13, 44, 32]
            }],
            chartOptions2: {
                chart: {
                type: 'bar',
                height: 430
                },
                plotOptions: {
                bar: {
                    horizontal: true,
                    dataLabels: {
                    position: 'top',
                    },
                }
                },
                dataLabels: {
                enabled: true,
                offsetX: -6,
                style: {
                    fontSize: '12px',
                    colors: ['#fff']
                }
                },
                stroke: {
                show: true,
                width: 1,
                colors: ['#fff']
                },
                xaxis: {
                categories: [2001, 2002, 2003, 2004, 2005, 2006, 2007],
                },
            },
            series3: [44, 55, 41, 17, 15],
            chartOptions3: {
                chart: {
                width: 380,
                type: 'donut',
                },
                plotOptions: {
                pie: {
                    startAngle: -45
                }
                },
                dataLabels: {
                enabled: false
                },
                fill: {
                type: 'gradient',
                },
                legend: {
                formatter: function(val, opts) {
                    return val + " - " + opts.w.globals.series[opts.seriesIndex]
                }
                },
                title: {
                text: 'Gradient Donut with custom Start-angle'
                },
                responsive: [{
                breakpoint: 480,
                options: {
                    chart: {
                    width: 200
                    },
                    legend: {
                    position: 'bottom'
                    }
                }
                }]
            },
        })
    }
</script>

<style lang="scss" scoped>
 .privilege-checkbox >>> .v-label {
     font-size:12px;
 }
 .v-data-table >>> .text-start{
    height:85px !important
  }
  h1, h2 {
    font-weight: normal;
  }
  .no-width {
    width: 0px !important;
    min-width: 0px !important;
    padding:25px 0px !important;
  }
  ul {
    list-style-type: none;
    padding: 0;
  }
  li {
    display: inline-block;
    margin: 0 10px;
  }
  a {
    color: #42b983;
  }
  .table-content {
    margin: 0 auto;
    margin-top: 25px;
    width: 96%;
    .v-input__control{
      min-width: 210px;
    }
  }
  .second-sidebar {
    box-shadow: 0 0 35px rgba(0,0,0,0.05);
    min-width:360px;
    padding:25px;
  }
  .add-btn {
    background: #207ddd;
    box-shadow: 5px 10px 20px #207ddd40;
    font-size: 12px;
  }
  .v-list--three-line .v-list-item, .v-list-item--three-line {
    min-height: 35px !important;
  }
  .v-list--rounded.v-list--three-line .v-list-item, .v-list--rounded.v-list--three-line .v-list-item:before, .v-list--rounded.v-list--three-line .v-list-item>.v-ripple__container {
      border-radius: 0px !important;
  }
  .v-list-item {
    text-align: left;
  }
  .v-list-item__title {
    font-size: 15px !important;
  }
  .v-list--nav .v-list-item:not(:last-child):not(:only-child), .v-list--rounded .v-list-item:not(:last-child):not(:only-child){
    margin-bottom: 0px !important;
  }
  .v-list-item__content{
    text-align: left !important;
  }
  .v-data-table th{
    min-height: 325px !important;
  }
</style>


// WEBPACK FOOTER //
// src/views/dashboard/statistics/index.vue